import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchUtilityAccountQuery,
  Flex_FetchUtilityAccountQueryVariables,
} from '~/typings/graphql';
import { FETCH_UTILITY_ACCOUNT } from './fetch-utility-account.queries';

export interface FetchUtilityAccountParams {
  utilityAccountId: number;
}

export interface FetchUtilityAccountResponse {
  utilityAccount: {
    id: number;
    accountNumber?: string | null | undefined;
    serviceAddressStreetOne?: string | null | undefined;
    serviceAddressCity?: string | null | undefined;
    serviceAddressState?: string | null | undefined;
    serviceAddressZip?: string | null | undefined;
  };
}

export const fetchUtilityAccount = async (
  params: FetchUtilityAccountParams,
): Promise<FetchUtilityAccountResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchUtilityAccountQuery,
    Flex_FetchUtilityAccountQueryVariables
  >({
    query: FETCH_UTILITY_ACCOUNT,
    variables: { utilityAccountId: params.utilityAccountId },
  });

  return data;
};
